var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivered1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 14.667V23.8337",
    stroke: "#219EBC",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0026 40.3333C13.1476 40.3333 5.96094 33.1467 5.96094 24.2917C5.96094 15.4367 13.1476 8.25 22.0026 8.25C30.8576 8.25 38.0443 15.4367 38.0443 24.2917",
    stroke: "#219EBC",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3.66699H27.5",
    stroke: "#219EBC",
    strokeWidth: 2.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8683 30.1303L32.2667 41.167H29.0583L33.715 30.4787H28.0133V27.802H36.8683V30.1303Z",
    fill: "#219EBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivered1);
export default __webpack_public_path__ + "static/media/delivered1.de7c13245dbf2e6d27b780f55815241d.svg";
export { ForwardRef as ReactComponent };